'use client';

import { useMemo } from 'react';

import { Store } from '@/types';
import { storeHasConfiguredDeliveryZones } from '@/utils';

/** Memoized {@link storeHasConfiguredDeliveryZones} for the current Prismic store. */
export function useStoreHasConfiguredDeliveryZones(store: Store | undefined) {
  return useMemo(
    () => storeHasConfiguredDeliveryZones(store),
    [store?.delivery_schedules],
  );
}
